import React, { useState } from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function FaqCard({ id, question, children, activeIndex, onToggle }) {
  const isOpen = activeIndex === id;
  const headingId = `heading-${id}`;
  const collapseId = `collapse-${id}`;

  return (
    <div className="card">
      <div className="card-header" id={headingId}>
        <h2 className="mb-0">
          <button
            className={`faq-btn${isOpen ? "" : " collapsed"}`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#${collapseId}`}
            aria-expanded={isOpen}
            aria-controls={collapseId}
            onClick={() => onToggle(id)}
          >
            {question}
          </button>
        </h2>
      </div>
      <div
        id={collapseId}
        className={`collapse${isOpen ? " show" : ""}`}
        aria-labelledby={headingId}
        data-bs-parent="#accordionExample"
      >
        <div className="card-body">{children}</div>
      </div>
    </div>
  );
}

function PaymentCard({ title, amount, description }) {
  return (
    <div className="faq-price-card">
      <span>{title}</span>
      <strong>{amount}</strong>
      <p>{description}</p>
    </div>
  );
}

function NajcescaPitanja() {
  const [t] = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Najčešća pitanja" />
      <section className="event event03 pt-150 pb-120 p-relative fix">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-md-8">
              <div className="faq-wrap pl-30">
                <div className="accordion" id="accordionExample">
                  <div>
                    <h4 className="pb-20">{t("faq.opsta")}</h4>
                    <FaqCard
                      id="study-duration"
                      question={t("faq.pitanje1")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      {t("faq.odgovor1")}
                    </FaqCard>
                    <FaqCard
                      id="semester-duration"
                      question={t("faq.pitanje2")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      {t("faq.odgovor2")}
                    </FaqCard>
                    <FaqCard
                      id="admission-conditions"
                      question={t("faq.pitanje3")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      <p>{t("faq.odgovor3.1")}</p>
                      <ol className="fpep-faq-list-numbered">
                        <li>{t("faq.odgovor3.2")}</li>
                        <li>{t("faq.odgovor3.3")}</li>
                        <li>{t("faq.odgovor3.4")}</li>
                        <li>{t("faq.odgovor3.5")}</li>
                        <li>{t("faq.odgovor3.6")}</li>
                      </ol>
                    </FaqCard>
                    <FaqCard
                      id="documents"
                      question={t("faq.pitanje4")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      <ul className="fpep-faq-list">
                        <li>{t("faq.odgovor4.1")}</li>
                        <li>{t("faq.odgovor4.2")}</li>
                        <li>{t("faq.odgovor4.3")}</li>
                        <li>{t("faq.odgovor4.4")}</li>
                      </ul>
                    </FaqCard>
                  </div>

                  <div>
                    <h4 className="pt-20 pb-20">{t("faq.skolarina")}</h4>
                    <FaqCard
                      id="payment-account"
                      question={t("faq.pitanje5")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      {t("faq.odgovor5")}
                    </FaqCard>
                    <FaqCard
                      id="payment-info"
                      question={t("faq.pitanje6")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      {t("faq.odgovor6")}
                    </FaqCard>
                    <FaqCard
                      id="undergraduate-tuition"
                      question={t("faq.pitanje7")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      <div className="faq-payment-grid">
                        <PaymentCard
                          title={t("faq.payment.oneTime")}
                          amount="1200 €"
                          description={t("faq.undergrad.oneTimeDesc")}
                        />
                        <PaymentCard
                          title={t("faq.payment.semester")}
                          amount="1400 €"
                          description={t("faq.undergrad.semesterDesc")}
                        />
                        <PaymentCard
                          title={t("faq.payment.installments")}
                          amount="1500 €"
                          description={t("faq.undergrad.installmentsDesc")}
                        />
                      </div>
                      <p className="faq-soft-note">{t("faq.undergrad.note")}</p>
                    </FaqCard>
                    <FaqCard
                      id="master-tuition"
                      question={t("faq.pitanje14")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      <div className="faq-payment-grid">
                        <PaymentCard
                          title={t("faq.payment.oneTime")}
                          amount="1500 €"
                          description={t("faq.master.oneTimeDesc")}
                        />
                        <PaymentCard
                          title={t("faq.payment.semester")}
                          amount="1700 €"
                          description={t("faq.master.semesterDesc")}
                        />
                        <PaymentCard
                          title={t("faq.payment.installments")}
                          amount="1800 €"
                          description={t("faq.master.installmentsDesc")}
                        />
                      </div>
                      <p className="faq-soft-note">{t("faq.master.note")}</p>
                    </FaqCard>
                    <FaqCard
                      id="payment-models"
                      question={t("faq.pitanje15")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      <ul className="fpep-faq-list">
                        <li>
                          <strong>{t("faq.payment.oneTime")}:</strong>{" "}
                          {t("faq.paymentModels.oneTime")}
                        </li>
                        <li>
                          <strong>{t("faq.payment.semester")}:</strong>{" "}
                          {t("faq.paymentModels.semester")}
                        </li>
                        <li>
                          <strong>{t("faq.payment.installments")}:</strong>{" "}
                          {t("faq.paymentModels.installments")}
                        </li>
                      </ul>
                      <p className="faq-soft-note">{t("faq.paymentModels.note")}</p>
                    </FaqCard>
                    <FaqCard
                      id="discounts"
                      question={t("faq.pitanje8")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      <ul className="fpep-faq-list">
                        <li>{t("faq.odgovor8.1")}</li>
                        <li>{t("faq.odgovor8.2")}</li>
                        <li>{t("faq.odgovor8.3")}</li>
                        <li>{t("faq.odgovor8.4")}</li>
                      </ul>
                    </FaqCard>
                  </div>

                  <div>
                    <h4 className="pt-20 pb-20">
                      {t("faq.specijalistickeStudije")}
                    </h4>
                    <FaqCard
                      id="specialist-current-status"
                      question={t("faq.pitanje16")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      <p>{t("faq.spec.a1")}</p>
                      <div className="faq-card-actions">
                        <Link to="/specijalisticke-studije" className="faq-inline-btn">
                          {t("faq.cta.specNotice")}
                        </Link>
                      </div>
                    </FaqCard>
                    <FaqCard
                      id="specialist-master-model"
                      question={t("faq.pitanje17")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      <p>{t("faq.spec.a2")}</p>
                      <p className="faq-soft-note">{t("faq.spec.disclaimer")}</p>
                    </FaqCard>
                    <FaqCard
                      id="specialist-related-masters"
                      question={t("faq.pitanje18")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      <p>{t("faq.spec.a3Lead")}</p>
                      <ul className="fpep-faq-list faq-link-list">
                        <li>
                          <Link to="/poslovna-ekonomija">
                            {t("master.poslovnaEkonomija")}
                          </Link>{" "}
                          — {t("faq.spec.businessEconomicsNote")}
                        </li>
                        <li>
                          <Link to="/ekonomija-javnog-sektora">
                            {t("master.ekonomijaJavnogSektora")}
                          </Link>{" "}
                          — {t("faq.spec.publicEconomicsNote")}
                        </li>
                      </ul>
                    </FaqCard>
                  </div>

                  <div>
                    <h4 className="pt-20 pb-20">{t("faq.prebacivanje")}</h4>
                    <FaqCard
                      id="transfer-exams"
                      question={t("faq.pitanje9")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      {t("faq.odgovor9")}
                    </FaqCard>
                    <FaqCard
                      id="diploma-recognition"
                      question={t("faq.pitanje10")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      {t("faq.odgovor10")}
                    </FaqCard>
                  </div>

                  <div>
                    <h4 className="pt-20 pb-20">{t("faq.nastava")}</h4>
                    <FaqCard
                      id="online-studies"
                      question={t("faq.pitanje11")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      {t("faq.odgovor11")}
                    </FaqCard>
                    <FaqCard
                      id="student-dorm"
                      question={t("faq.pitanje12")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      {t("faq.odgovor12")}
                    </FaqCard>
                    <FaqCard
                      id="mobility"
                      question={t("faq.pitanje13")}
                      activeIndex={activeIndex}
                      onToggle={handleToggle}
                    >
                      <p>{t("faq.odgovor13.1")}</p>
                      <p>{t("faq.odgovor13.2")}</p>
                    </FaqCard>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 pt-10">
              <aside className="sidebar-widget">
                <section
                  id="custom_html-5"
                  className="widget_text widget widget_custom_html"
                >
                  <h2 className="widget-title">{t("sidebar.follow")}</h2>
                  <div className="textwidget custom-html-widget">
                    <div className="widget-social">
                      <a
                        href="https://www.facebook.com/fpebar.me"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Facebook"
                      >
                        <i className="fab fa-facebook-f" />
                      </a>
                      <a
                        href="https://www.instagram.com/fpepbar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Instagram"
                      >
                        <i className="fab fa-instagram" />
                      </a>
                      <a
                        href="https://www.youtube.com/@fpepbar"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fab fa-youtube" />
                      </a>
                      <a
                        href="https://www.tiktok.com/@fpepbar"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow us on Tiktok"
                        title="Tiktok"
                      >
                        <i className="fab fa-tiktok" />
                      </a>
                      <a
                        href="https://www.linkedin.com/school/fpepbar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow us on LinkedIn"
                        title="LinkedIn"
                      >
                        <i className="fab fa-linkedin-in" />
                      </a>
                    </div>
                  </div>
                </section>
                <section id="categories-1" className="widget widget_categories">
                  <h2 className="widget-title">{t("sidebar.useful")}</h2>
                  <ul>
                    <li className="cat-item cat-item-16">
                      <Link to="/o-fpep">{t("about.fpep")}</Link>
                    </li>
                    <li className="cat-item cat-item-23">
                      <Link to="/akreditacija-fpep">
                        {t("admission.Akreditacija")}
                      </Link>
                    </li>
                    <li className="cat-item cat-item-18">
                      <Link to="/upis">{t("upis.title")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/cijene-studija">
                        {t("admission.Skolarina")}
                      </Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/projekti">{t("saradnja.projekti")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/galerija">{t("navbar.Gallery")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/novosti">{t("navbar.News")}</Link>
                    </li>
                  </ul>
                </section>
                <section
                  id="recent-posts-4"
                  className="widget widget_recent_entries"
                >
                  <h2 className="widget-title">{t("sidebar.study")}</h2>
                  <ul>
                    <li>
                      <span className="post-date">
                        <strong>{t("programs.osnovne")}</strong> <br />
                      </span>
                      <Link to="/racunovodstvo-finansije-i-bankarstvo">
                        {t("osnovne.rfb")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/menadzment">
                        {t("osnovne.menadzment")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-osnovne">
                        {t("osnovne.pravo")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <span className="post-date">
                        <strong>{t("programs.master")}</strong> <br />
                      </span>
                      <Link to="/poslovna-ekonomija">
                        {t("master.poslovnaEkonomija")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/ekonomija-javnog-sektora">
                        {t("master.ekonomijaJavnogSektora")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-master">
                        {t("master.pravo")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <span className="post-date">
                        <strong>{t("programs.specijalisticke")}</strong> <br />
                      </span>
                      <Link to="/specijalisticke-studije">
                        {t("faq.cta.specNotice")}
                        <br />
                      </Link>
                    </li>
                  </ul>
                </section>
              </aside>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default NajcescaPitanja;
